module.exports = __webpack_public_path__ + "static/email-contact-cbbb2e0a1406349c89f9815e510ef19b.png";